<div class="update-shell">
  <div class="update-glow update-glow--pink"></div>
  <div class="update-glow update-glow--blue"></div>

  <div class="update-card">
    <section class="update-panel update-panel--visual">
      <video
        class="update-video"
        autoplay
        muted
        loop
        playsinline
        aria-label="Update Password Video"
      >
        <source
          src="https://sharajman.com/wp-content/uploads/2026/04/nea-login.mp4"
          type="video/mp4"
        />
      </video>

      <div class="update-overlay"></div>

      <div class="update-visual-content">
        <div class="update-pill">Nepal Electricity Authority</div>

        <div class="update-copy">
          <p class="update-copy__eyebrow">Security first</p>
          <h1>Update Password</h1>
          <p>
            Create a new password for your account to complete the sign in flow.
          </p>
        </div>
      </div>
    </section>

    <section class="update-panel update-panel--form">
      <div class="update-brand">
        <img [src]="logoPath" alt="Nepal Electricity Authority Logo" />
      </div>

      <div class="update-heading">
        <h2>Update Password</h2>
        @if (resetToken) {
          <p>Checking whether your reset link is still valid</p>
        } @else {
          <p>Set a new password to continue to the dashboard</p>
        }
      </div>

      @if (isLinkChecking) {
        <div class="link-state">
          <div class="link-state__title">Validating reset link...</div>
          <p class="link-state__message">Please wait while we confirm your password reset link.</p>
        </div>
      } @else if (resetToken && !isLinkValid) {
        <div class="link-state link-state--error">
          <div class="link-state__title">Link is already used or expired</div>
          <p class="link-state__message">{{ linkMessage || 'Reset link is invalid or expired' }}</p>
          <button type="button" class="update-submit update-submit--secondary" routerLink="/signin">
            Go to Sign In
          </button>
        </div>
      } @else {
        <form class="update-form" [formGroup]="form" (ngSubmit)="updatePassword()">
          <div class="field-group">
            <label for="password">Password</label>
            <div class="password-field">
              <input
                id="password"
                formControlName="password"
                placeholder="Enter your password"
                autocomplete="new-password"
                [type]="showPassword ? 'text' : 'password'"
              />

              <button
                type="button"
                class="password-toggle"
                (click)="togglePasswordVisibility()"
                [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
              >
                @if (showPassword) {
                  <span>Hide</span>
                } @else {
                  <span>Show</span>
                }
              </button>
            </div>

            @if (form.get('password')?.touched && form.get('password')?.errors) {
              <div class="field-error">
                @if (form.get('password')?.errors?.['required']) {
                  <span>Password is required</span>
                }
                @if (form.get('password')?.errors?.['minlength']) {
                  <span>Password must be at least 8 characters</span>
                }
              </div>
            }
          </div>

          <div class="field-group">
            <label for="confirm_password">Confirm Password</label>
            <div class="password-field">
              <input
                id="confirm_password"
                [type]="showConfirmPassword ? 'text' : 'password'"
                formControlName="confirm_password"
                placeholder="Confirm your password"
                autocomplete="new-password"
              />

              <button
                type="button"
                class="password-toggle"
                (click)="toggleConfirmPasswordVisibility()"
                [attr.aria-label]="
                  showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'
                "
              >
                @if (showConfirmPassword) {
                  <span>Hide</span>
                } @else {
                  <span>Show</span>
                }
              </button>
            </div>

            @if (form.get('confirm_password')?.touched && form.get('confirm_password')?.errors) {
              <div class="field-error">
                @if (form.get('confirm_password')?.errors?.['required']) {
                  <span>Confirm password is required</span>
                }
              </div>
            }
          </div>

          @if (form.touched && form.errors?.['passwordMismatch']) {
            <div class="message message--error">
              Password and confirm password must match.
            </div>
          }

          @if (error) {
            <div class="message message--error">
              {{ error }}
            </div>
          }

          <button type="submit" class="update-submit" [disabled]="isSubmitting">
            {{ isSubmitting ? 'Updating...' : 'Update Password' }}
          </button>
        </form>
      }
    </section>
  </div>
</div>
